'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _interceptUpdater = require('coact-utils/interceptUpdater');

var _interceptUpdater2 = _interopRequireDefault(_interceptUpdater);

var _inputEnhancer = require('../Input/inputEnhancer');

var _inputEnhancer2 = _interopRequireDefault(_inputEnhancer);

var _autoFocusWhenLoaded = require('../enhancers/autoFocusWhenLoaded');

var _autoFocusWhenLoaded2 = _interopRequireDefault(_autoFocusWhenLoaded);

var _DatePicker = require('./DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  value: _propTypes.any,
  onChange: _propTypes.func.isRequired,
  schema: _propTypes.object,
  block: _propTypes.object,
  formatter: _propTypes.func,
  parser: _propTypes.func
}), (0, _flattenDefaultProp2.default)('block'), (0, _flattenDefaultProp2.default)('schema'), (0, _interceptUpdater2.default)('onChange', function () {
  return function (value) {
    return value && (0, _moment2.default)(value).toDate();
  };
}), (0, _withHandlers2.default)({
  // `react-datepicker` pass `event` as the second arg.
  // Omit it by only passing `input` to parent `onChange`.
  // The second arg of `onChange` is for callback
  onChange: function onChange(_ref) {
    var _onChange = _ref.onChange;
    return function (input) {
      return _onChange(input);
    };
  }
}), (0, _withProps2.default)(function (_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange;
  return {
    selected: value ? (0, _moment2.default)(value) : null,
    // inputEnhancer 會對 onChange 套用用文字輸入時的處理
    // 但 datepicker 會直接 callback moment value
    // 所以先把接收 moment value 的 onChange 放在 onDateChange 上
    onDateChange: onChange
  };
}), (0, _withProps2.default)({ type: 'date' }), _inputEnhancer2.default, (0, _withHandlers2.default)({
  // datepicker 會把 input 改變的值 callback 到 onChangeRaw
  onChangeRaw: function onChangeRaw(_ref3) {
    var onChange = _ref3.onChange;
    return function (event) {
      onChange(event);
      event.preventDefault();
    };
  }
}), (0, _withProps2.default)(function (_ref4) {
  var onDateChange = _ref4.onDateChange;
  return {
    // 把接收 momnet 的 onChange 換回來傳給 datepicker
    onChange: onDateChange
  };
}), _autoFocusWhenLoaded2.default, (0, _branch2.default)(function (_ref5) {
  var inputRef = _ref5.inputRef;
  return !!inputRef;
}, (0, _withHandlers2.default)({
  inputRef: function inputRef(_ref6) {
    var _inputRef = _ref6.inputRef;
    return function (element) {
      return _inputRef(
      // add focus as an alias of setFocus
      element ? Object.assign(element, { focus: element.setFocus }) : element);
    };
  }
})), (0, _exposeProps2.default)([
// for datepicker
'name', 'selected', 'onChange',

// for input
'value', 'disabled', 'onChangeRaw', 'onFocus', 'onBlur', 'isInvalid', 'inputRef']));

var DatePicker = enhancer(_DatePicker2.default);
DatePicker.displayName = 'DatePicker';

exports.default = DatePicker;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/DatePicker/index.js
// module id = 1747
// module chunks = 0